// src/components/SafeHtml.js
//
// The one way lesson HTML is allowed to reach the DOM.
//
// Every block body, caption, card and generated citation used to go straight
// into dangerouslySetInnerHTML. Routing them through here means the allowlist
// in utils/sanitizeHtml.ts is enforced at render time, which is the moment
// that actually matters: content can arrive from an imported file, an
// autosaved draft in localStorage, or the editor, and all three land here.
//
// Usage mirrors the div it replaces:
//   <SafeHtml className="rich-editor-content" html={block.content} />
//   <SafeHtml as="span" style={{ color }} html={item.content} />
//
// `profile="slideLayout"` swaps the strict rich-text allowlist for the slightly
// wider one hand-written slide layouts need (inert layout containers, data-*).
// Only the custom HTML/CSS block should ask for it; everything else is rich
// text and belongs on the default.

import React, { useMemo } from 'react';
import { sanitizeHtml, sanitizeSlideLayoutHtml } from '../utils/sanitizeHtml';

const PROFILES = {
  richText: sanitizeHtml,
  slideLayout: sanitizeSlideLayoutHtml,
};

const SafeHtml = ({ html, as: Tag = 'div', profile = 'richText', ...rest }) => {
  const sanitize = PROFILES[profile] || sanitizeHtml;
  const clean = useMemo(() => sanitize(html), [sanitize, html]);
  return <Tag {...rest} dangerouslySetInnerHTML={{ __html: clean }} />;
};

export default SafeHtml;
